import { render, staticRenderFns } from "./Soundtrack.vue?vue&type=template&id=3c4086c3&"
import script from "./Soundtrack.vue?vue&type=script&lang=js&"
export * from "./Soundtrack.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports